<div class="container-fluid">
  <div class="header-row">
    <div class="header-left">
      <div class="header-title">
        <span>
          {{tab_name}}
        </span>
        <button *ngIf="query" (click)="toggleQueryBox()" class="btn btn-link p-0 eye-btn">
          <i class="bi" [matTooltip]="showQueryBox ? 'Hide Query' : 'View Query'"
            [ngClass]="showQueryBox ? 'bi-eye-slash' : 'bi-eye'"
            matTooltipPosition="above">
          </i>
        </button>
      </div>
  
      <div *ngIf="showQueryBox && query" class="alert alert-info query-alert" role="alert">
        {{ query || 'No query found' }}
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12" style="margin:10px 10px 0 10px;">
      <!-- Only show description when not in popup mode -->
      <div *ngIf="!isPopup && (tabs$ | async)?.search_type=='company'">
        Displaying up to 100 of the most recent inventions (patent families) owned by {{tab_name}}. 
        Adjust the end date or quality score to refine results. If fewer than 100 match, all available are shown.
      </div>

      <div *ngIf="!isPopup && (tabs$ | async)?.search_type=='theme'">
        Displaying up to 100 of the most recent inventions (patent families) in this technology area. Adjust the end date or quality score to refine results. If fewer than 100 match, all available are shown.

      </div>
    </div>
    <div class="col m-10" style="margin:10px 10px 0 10px;">
      <div class="card keywords" style="padding:15px;">
        <!-- Hide controls when in popup mode to prevent duplication -->
        <div class="d-flex justify-content-between align-items-center mb-3" style="flex-wrap: wrap;">
          <div class="ai-summary">
            <button class="btn ai-generate-button" (click)="generateSummary()" [disabled]="loadingSummary||showSpinner|| inventions_data.length==0 ">
              <ng-container *ngIf="!loadingSummary">
                Generate AI Summary
              </ng-container>
              <ng-container *ngIf="loadingSummary">
                <span class="spinner-border spinner-border-sm text-light me-2" role="status" aria-hidden="true"></span>
                Generating...
              </ng-container>
            </button>
          </div>

          <div class="filters d-flex flex-wrap align-items-center" [formGroup]="form" style="gap: 10px;">
            <label for="date_end">End Date:</label>
            <input class="form-control" type="date" formControlName="date_end" style="width:150px;" name="date_end"  [max]="getToday()">

            <label for="quality_filter">Quality Filter:
              <i class="bi bi-info-circle" style="margin-left: 5px; cursor: pointer;" [matTooltip]="'Inventions scoring higher than 97 are considered High Quality Inventions.
              '" matTooltipPosition="above">
              </i>
            </label>
            <div class="dropdown" name="quality_filter">
              <button class="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown">
                {{ form.get('quality_filter')?.value | titlecase }}
              </button>
              <ul class="dropdown-menu">
                <li><button class="dropdown-item" (click)="form.get('quality_filter')?.setValue('all')">All</button>
                </li>
                <li><button class="dropdown-item" (click)="form.get('quality_filter')?.setValue('high')">High
                    Quality</button></li>
              </ul>
            </div>

            <button type="submit" class="btn btn-primary search-button" (click)="onSubmit()">Submit</button>

            <button class="btn btn-primary"  (click)="downloadExcel()" matTooltip="Download Excel">
              <i class="bi bi-download"></i>
            </button>
          </div>
        </div>



        <div *ngIf="summaryText" class="card p-3" style="background:#f8f9fa; border-left: 5px solid #7c6bb8;">
          <p style="margin:0; font-style: italic;">{{ summaryText }}</p>
        </div>

        <div class="spinner-border text-primary" role="status" *ngIf="showSpinner">
          <span class="visually-hidden">Loading...</span>
        </div>

        <div class="empty-state" *ngIf="noInventionsFound">
          <div class="empty-state-content">
            <i class="bi bi-search empty-state-icon"></i>
            <h4>No Inventions Found</h4>
            <p> No inventions found within the search parameters. 
            </p>
          </div>
        </div>

        <div class="alert alert-info" role="alert" role="alert" *ngIf="inventions_data_loading_failed">
          <p>
            Unfortunately, we weren't able to load the data. Please try again later, or for more assistance, please
            contact
            <a href="mailto:tech@quant-ip.com" style="color: blue">info&#64;quant-ip.com</a>.
          </p>
        </div>

        <table class="table table-hover table-condensed" *ngIf="showResults && inventions_data.length > 0">

          <thead>
            <tr style="background-color: #96c242;">
              <th style="width:3%">ID</th>
              <th style="width:40%">Invention Title</th>

              <th style="width:8%;text-align: center;">Date of Publication
                <i class="bi bi-info-circle" style="margin-left: 5px; cursor: pointer;"
                  [matTooltip]="'Earliest publication date in the patent family.'" matTooltipPosition="above">
                </i>
              </th>
              <th style="width:23%">Filing Entities
                <i class="bi bi-info-circle" style="margin-left: 5px; cursor: pointer;" [matTooltip]="'List of ultimate parent companies that own the invention or the filing subsidiary, considering corporate trees and M&A activity.
                '" matTooltipPosition="above">
                </i>
              </th>
              <th style="width:15%">Primary <br>Techfield
                <i class="bi bi-info-circle" style="margin-left: 5px; cursor: pointer;" [matTooltip]="'Quant IP Technology Field that is seen most often among the patent classifications of the patent family.'" matTooltipPosition="above">
                </i>
              </th>
              <th style="width:7%">Quality <br> Score
                <i class="bi bi-info-circle" style="margin-left: 5px; cursor: pointer;" [matTooltip]="'Proprietary quality indicator based on grant robustness, market coverage and technological relevance. Each invention receives a score between 0-100, relative to similar inventions.
                '" matTooltipPosition="above">
                </i>
              </th>
              <th style="width:4%">URL</th>
            </tr>

          </thead>
          <tbody>

            <tr
              *ngFor="let invention of inventions_data | paginate: {id: 'pag_11', itemsPerPage: 10, currentPage: paginator_1_page }">
              <td>
                <i class="bi bi-copy" style="cursor:pointer;" matTooltip="Copy family Id of the invention"
                  [cdkCopyToClipboard]="invention.family_id"></i>
              </td>
              <td>
                <span class="truncate-tooltip" [matTooltip]="invention.invention_title">
                  {{ invention.invention_title | titlecase }} 
                </span>
              
              </td>
              <td>{{ invention.date_publication | date: 'dd/MM/yyyy' }}


              </td>
              <td>
                <div class="truncate-multiline-tooltip" [title]="invention.applicants">
                  <ng-container *ngFor="let name of invention.applicants">
                    {{ name.trim() }}<br>
                  </ng-container>
                </div>

              </td>
              <td>{{ invention.techfield }}</td>
              <td>{{ invention.quality_score | nullableNumber: '1.1-1' }}</td>
              <td>
                <a [href]="invention.link_espacenet || null" 
                [attr.target]="invention.link_espacenet ? '_blank' : null"
                [matTooltip]="invention.link_espacenet ? 'Click to view the patent in espacenet' : 'No link available'"
                [style.pointer-events]="invention.link_espacenet ? 'auto' : 'none'"
                [style.opacity]="invention.link_espacenet ? '1' : '0.4'">
               <i class="bi bi-link-45deg me-2"></i>
             </a>

              </td>

            </tr>
          </tbody>

        </table>

        <pagination-controls id="pag_11" [maxSize]="10" (pageChange)="paginator_1_page = $event"
          previousLabel="Previous" nextLabel="Next">
        </pagination-controls>
      </div>
    </div>
  </div>
</div>